import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import Hashids from "hashids";
import {apiPath, serverToken} from "../utils/api";
import axios from "axios";
import {CgSpinner} from "react-icons/cg";

function UpdateServerPrice() {

    const navigate = useNavigate();
    const hashids = new Hashids('', 10)


    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState(null);
    const [priceDay, setPriceDay] = useState(0.0)
    const [priceNight, setPriceNight] = useState(0.0)

    let {id} = useParams();

    const userGoogleID = localStorage.getItem("G_ID");

    useEffect(() => {


        let decodedID = hashids.decode(id)

        setIsLoading(true);

        const headers = {
            'Authorization': serverToken,
        };

        axios.get(apiPath + '/get-server-price/' + decodedID[0], {headers})
            .then(data => {
                setData(data.data);
                setPriceDay(data.data.price.price_day)
                setPriceNight(data.data.price.price_night)
                setIsLoading(false);
            })

            .catch(error => {
                setIsLoading(false);
            });

    }, []);

    if (!data) {
        return (
            <div className="container mx-auto h-screen flex justify-center items-center">
                <CgSpinner className="w-8 h-8 animate-spin text-gray-400"/>
            </div>
        );
    }

    const handelPriceUpdate = (priceDay,priceNight) => {

        setIsLoading(true);

        if (userGoogleID === null) {
            navigate('/iniciar-sesion');
        }

        const headers = {
            'Authorization': serverToken,
        };

        const priceData = {
            item: data.price.id,
            google_id: userGoogleID,
            price_day: priceDay,
            price_night: priceNight
        };

        axios.get(apiPath + '/edit-server-price?item=' + priceData.item.toString()+'&google_id='+priceData.google_id.toString() +'&price_day='+ priceData.price_day.toString()+'&price_night='+ priceData.price_night.toString(), {headers})
            .then(res => {
                setIsLoading(false);
                navigate('/admin/ajustes');
            })

            .catch(error => {
                setIsLoading(false);
                navigate('/admin/ajustes');
            });
    }

    return (
        <>
            <div className="flex items-center justify-center py-8 px-4">

                <div className="w-full md:w-1/2 rounded-md shadow-sm py-8 px-5 dark:bg-gray-600 bg-white">

                    <div className="relative flex pb-5 items-center">
                        <div className="flex-grow border-t border-gray-200 dark:border-gray-500"></div>
                        <p className="flex-shrink mx-4 text-gray-600 dark:text-gray-100">Editar precio</p>
                        <div className="flex-grow border-t border-gray-200 dark:border-gray-500"></div>
                    </div>

                    <h3 className="text-gray-600 dark:text-gray-100">{data.price.title}</h3>
                    <p className="text-gray-500 dark:text-gray-50 text-sm">{data.price.description}</p>

                    <p className="mt-5 mb-2">Precio durante el día</p>
                    <input type="number" className="w-full outline-none bg-gray-100 mb-5 py-2 px-3 rounded" onChange={ (e) => setPriceDay(parseFloat(e.target.value))}
                           value={priceDay}/>

                    <p className="mt-5 mb-2">Precio durante la noche</p>
                    <input type="number" className="w-full outline-none bg-gray-100 mb-5 py-2 px-3 rounded" onChange={ (e) => setPriceNight(parseFloat(e.target.value))}
                           value={priceNight}/>

                    <div className="flex flex-col md:flex-row gap-y-5 lg:gap-y-0 justify-end my-5 gap-x-4">

                        <button
                            onClick={() => navigate('/admin/ajustes')}
                            className="px-10 py-2 bg-white border hover:bg-gray-100 text-gray-800 rounded-full">Regresar
                        </button>

                        <button
                            onClick={() => handelPriceUpdate(priceDay,priceNight)}
                            className="px-10 py-2 bg-sky-500 hover:bg-sky-400 text-white rounded-full">Actualizar
                        </button>
                    </div>

                </div>
            </div>
        </>
    );
}

export default UpdateServerPrice;